import { connect } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
  TablePagination,
  Box,
  Paper,
  CardContent,
  Modal,
  IconButton,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Alert,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import PersonAddRounded from "@mui/icons-material/PersonAddRounded";
import { Delete, Edit, Mode } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

// Category Types Options
const CategoryTypes = [
  { label: "सैद्धांतिक", value: "Theory" },
  { label: "प्रात्यक्षिक", value: "Practical" },
];

export const TrainingCategories = ({ userDetails }) => {
  const classes = useStyles();

  // Data variables
  const [TrainingCategoryName, setTrainingCategoryName] = useState("");
  const [description, setDescription] = useState();
  const [categoryType, setCategoryType] = useState(""); // New State for Type
  const [TrainerData, setTrainerData] = useState([]);
  const [editData, setEditData] = useState();
  const [dataLoad, setDataLoad] = useState(false);
  const [trainingCategory_id, setId] = useState();
  const [deleteTrainingCategory, setDeleteTrainingCategory] = useState();

  // Table Pagination variables
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Modal variables
  const [openTrainingModule, setOpenTrainingModule] = useState(false);
  const [EditTrainingModule, setEditTrainingModule] = useState(false);

  // Error variables
  const [NameError, setNameError] = useState(false);
  const [DescriptionError, setDescriptionError] = useState(false);
  const [TypeError, setTypeError] = useState(false);
  const [Error, setError] = useState(false);

  useEffect(() => {
    getTrainerData();
  }, []);

  const getTrainerData = async () => {
    setDataLoad(true);
    await axios
      .get(
        process.env.REACT_APP_BASE_URL +
        "/trainingsubcategory/gettrainingsubcategorylist"
      )
      .then((res) => {
        setTrainerData(res.data);
        setDataLoad(false);
      })
      .catch((err) => {
        setDataLoad(false);
      });
  };

  const foramvaliadate = () => {
    let IsformValid = true;

    if (!TrainingCategoryName || TrainingCategoryName.trim().length === 0) {
      IsformValid = false;
      setNameError(true);
    }

    if (!description || description.trim().length === 0) {
      IsformValid = false;
      setDescriptionError(true);
    }

    if (!categoryType) {
      IsformValid = false;
      setTypeError(true);
    }

    return IsformValid;
  };

  const handleAdd = async () => {
    setNameError(false);
    setDescriptionError(false);
    setTypeError(false);

    if (foramvaliadate()) {
      const data = {
        trainingSubjectCategoryName: TrainingCategoryName,
        description: description,
        categoryType: categoryType, // Sending Type
        createdBy: userDetails?._id,
      };

      await axios
        .post(
          process.env.REACT_APP_BASE_URL +
          // "/trainingcategory/inserttrainingcategory",
          "/trainingsubcategory/inserttrainingsubcategory",
          data
        )
        .then((res) => {
          setOpenTrainingModule(false);
          getTrainerData();
        })
        .catch((err) => {
          console.log("Error adding category", err);
        });
    }
  };

  const openModule = () => {
    setTrainingCategoryName("");
    setDescription("");
    setCategoryType("");
    setOpenTrainingModule(true);
  };

  const openEdit = (row) => {
    setTrainingCategoryName(row?.trainingSubjectCategoryName);
    setDescription(row?.description);
    setCategoryType(row?.categoryType || ""); // Set existing type
    setId(row?._id);
    setEditTrainingModule(true);
  };

  const openDelete = (row) => {
    setId(row?._id);
    setDeleteTrainingCategory(true);
  };

  const handleDelete = async () => {
    await axios
      .put(
        process.env.REACT_APP_BASE_URL +
        "/trainingsubcategory/trainingsubcategorydelete",
        { trainingCategory_id }
      )
      .then((res) => {
        setDeleteTrainingCategory(false);
        getTrainerData();
      })
      .catch((err) => {
        console.log("Error deleting", err);
      });
  };

  const handleEdit = async (e) => {
    if (foramvaliadate()) {
      const trainingCategoryName = TrainingCategoryName;
      const data = {
        trainingCategory_id,
        trainingSubjectCategoryName: trainingCategoryName,
        description,
        categoryType, // Update Type
      };

      await axios
        .put(
          process.env.REACT_APP_BASE_URL +
          "/trainingsubcategory/trainingsubcategoryupdate",
          data
        )
        .then((res) => {
          setEditTrainingModule(false);
          getTrainerData();
        })
        .catch((err) => {
          console.log("Error updating", err);
        });
    }
  };

  return (
    <div className={classes.main}>
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <Box sx={{ flex: 1 }}>
          <h1>Training Category</h1>
        </Box>
        <Box>
          <div style={{ marginTop: 30, right: 0 }}>
            <Button variant="contained" onClick={() => openModule()}>
              <PersonAddRounded style={{ marginRight: 10 }} />
              Add Training Category
            </Button>
          </div>
        </Box>
      </div>

      {dataLoad ? (
        <CircularProgress color="primary" />
      ) : (
        <Paper sx={{ overflow: "hidden", width: "90%", marginTop: 2 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>SR No.</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Category Name</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Type</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Description</strong>
                  </TableCell>
                  <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {TrainerData !== "No data found" && TrainerData.length > 0 ? (
                  TrainerData.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  ).map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.trainingSubjectCategoryName}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.categoryType === "Theory" ? "सैद्धांतिक" : row?.categoryType === "Practical" ? "प्रात्यक्षिक" : row?.categoryType}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.description}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          <Edit
                            variant="contained"
                            style={{ color: "green", cursor: "pointer" }}
                            onClick={() => openEdit(row)}
                          />
                          <Delete
                            variant="contained"
                            style={{ color: "red", cursor: "pointer" }}
                            onClick={() => openDelete(row)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>NO Data Found</TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={
              TrainerData !== "No data found" && TrainerData?.length > 0
                ? TrainerData?.length
                : 0
            }
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(+e.target.value);
              setPage(0);
            }}
          />
        </Paper>
      )}

      {/* Add Training Category */}
      <Modal
        className={classes.middlePosition}
        open={openTrainingModule}
        onClose={() => setOpenTrainingModule(false)}
      >
        <Paper className={classes.profilemodal}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h6" component="div">
              Add Training Category
            </Typography>
            <IconButton onClick={() => setOpenTrainingModule(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <div className={classes.modalContent}>
            <CardContent className={classes.cardContent}>
              <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                <FormControl sx={{ m: 1, marginRight: 3, width: 300 }}>
                  <TextField
                    error={NameError}
                    label="Category Name"
                    value={TrainingCategoryName}
                    onChange={(e) => setTrainingCategoryName(e.target.value)}
                    helperText={NameError ? "Please Enter Category Name" : null}
                  />
                </FormControl>

                <FormControl sx={{ m: 1, marginRight: 3, width: 300 }}>
                  <InputLabel>Category Type</InputLabel>
                  <Select
                    value={categoryType}
                    label="Category Type"
                    onChange={(e) => setCategoryType(e.target.value)}
                    error={TypeError}
                  >
                    {CategoryTypes.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                  {TypeError && <span style={{ color: "red", fontSize: 12 }}>* Please Select Type</span>}
                </FormControl>
              </div>
              <FormControl sx={{ m: 1, width: "97%" }}>
                <TextField
                  label="Description"
                  multiline
                  rows={2}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  helperText={DescriptionError ? "Please Enter Description" : null}
                  error={DescriptionError}
                />
              </FormControl>
            </CardContent>

            <Button
              variant="contained"
              style={{ margin: 10 }}
              endIcon={<SendIcon />}
              onClick={handleAdd}
            >
              ADD Category
            </Button>
          </div>
        </Paper>
      </Modal>

      {/* Update Training Category */}
      <Modal
        className={classes.middlePosition}
        open={EditTrainingModule}
        onClose={() => setEditTrainingModule(false)}
      >
        <Paper className={classes.profilemodal}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h6" component="div">
              Update Training Category
            </Typography>
            <IconButton onClick={() => setEditTrainingModule(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <div className={classes.modalContent}>
            <CardContent className={classes.cardContent}>
              <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                <FormControl sx={{ m: 1, marginRight: 3, width: 300 }}>
                  <TextField
                    error={NameError}
                    label="Category Name"
                    value={TrainingCategoryName}
                    onChange={(e) => setTrainingCategoryName(e.target.value)}
                    helperText={NameError ? "Please Enter Category Name" : null}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, marginRight: 3, width: 300 }}>
                  <InputLabel>Category Type</InputLabel>
                  <Select
                    value={categoryType}
                    label="Category Type"
                    onChange={(e) => setCategoryType(e.target.value)}
                    error={TypeError}
                  >
                    {CategoryTypes.map((type) => (
                      <MenuItem key={type.value} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <FormControl sx={{ m: 1, width: "97%" }}>
                <TextField
                  label="Description"
                  multiline
                  rows={2}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  helperText={DescriptionError ? "Please Enter Description" : null}
                  error={DescriptionError}
                />
              </FormControl>
            </CardContent>

            <Button
              variant="contained"
              style={{ margin: 10 }}
              endIcon={<SendIcon />}
              onClick={handleEdit}
            >
              Update Category
            </Button>
          </div>
        </Paper>
      </Modal>

      {/* Delete Modal */}
      <Modal
        className={classes.middlePosition}
        open={deleteTrainingCategory}
        onClose={() => setDeleteTrainingCategory(false)}
      >
        <Paper className={classes.profilemodal}>
          <Stack direction="row" style={{ display: "flex", justifyContent: "center" }}>
            <Typography variant="h6" style={{ textAlign: "center" }}>
              Are You Want To Delete Training Category?
            </Typography>
          </Stack>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "21px" }}>
            <Button
              variant="contained"
              style={{ margin: 10 }}
              onClick={() => setDeleteTrainingCategory(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{ margin: 10, backgroundColor: "red" }}
              endIcon={<Delete />}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        </Paper>
      </Modal>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: 30,
  },
  profilemodal: {
    width: "800px",
    background: "white",
    borderRadius: "20px !important",
    margin: "20px",
    padding: "20px",
  },
  middlePosition: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  cardContent: {
    display: "flex",
    width: "90%",
    justifyContent: "center",
    flexDirection: "column",
  },
}));

const mapStateToProps = (state) => {
  return {
    userDetails: state.auth.userDetails,
  };
};

export default connect(mapStateToProps, {})(TrainingCategories);